export default __webpack_public_path__ + "static/media/close-project.7ac51f9f.svg";